import { useContext, useEffect, useState } from 'react'
import HeaderLogo from '../../shared/HeaderLogo'
import { ReactComponent as SearchIcon } from '@svgs/keyline/search.svg'
import { getLink, prefixLocale } from '@helpers/env'
import CartMenuIcon from '@components/Header/shared/CartMenuIcon'
import { CartEvent } from '@components/Header'
import MobileMenuDrawerOverlay from '@components/Header/HeaderWrapper/mobile/MobileMenuDrawerOverlay'
import styles from './styles.module.scss'
import { analytics } from '@helpers/analytics'
import { HEADER_ANALYTICS_EVENT_NAMES } from '@components/Header/consts'
import { getCookieByName } from '@helpers/session'
import { useDispatch } from 'react-redux'
import { flyoutMenuTrackerAction } from '@store/redux/actions/popUpsTrackerActions'
import { useRouter } from 'next/router'
import AppContext from '@components/AppContext'
import { useLogin } from '@api/accounts/auth/hooks/useLogin'
import { ACCOUNT_PAGE_NAME } from '@api/accounts/auth/consts'
import AccountMenuIcon from '@components/Header/shared/AccountMenuIcon'

export default function MobileHeader({
  onCartOpen,
  isFitFinderOpen
}: {
  onCartOpen: (e: CartEvent['event']) => void
  isFitFinderOpen: boolean
}) {
  const { headerTheme } = useContext(AppContext)
  const { login, isLoggedIn } = useLogin()
  const router = useRouter()
  const dispatch = useDispatch()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const handleBurgerClick = () => {
    setIsMobileMenuOpen(true)
    analytics('Click', {
      category: 'Menu Click'
    })
  }
  const handleCloseMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  useEffect(() => {
    if (isFitFinderOpen && isMobileMenuOpen) {
      setIsMobileMenuOpen(false)
    }
  }, [isFitFinderOpen, isMobileMenuOpen])

  useEffect(() => {
    // Updates the Newsletter modal popup store status
    if (!getCookieByName('hideNewsletterPrompt')) {
      dispatch(flyoutMenuTrackerAction({ flyoutMenu: isMobileMenuOpen }))
    }
  }, [dispatch, isMobileMenuOpen])

  const isSearchDrawerOpen = router.asPath?.includes('/pages/search')
  const isNewAccountPages = process.env.NEW_ACCOUNT_PAGES_ENABLED === 'true'

  const handleClickAccountIcon = () => {
    if (isLoggedIn) {
      const accountUrl = `${prefixLocale()}/${ACCOUNT_PAGE_NAME}?page=overview`
      router.push(accountUrl)
    } else {
      login()
    }
  }

  return (
    <>
      <div className={`${styles.MobileHeader} ${headerTheme}`}>
        <HeaderLogo
          width="44"
          height="37"
          onClick={() => {
            analytics('Click', {
              category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
              label: 'Logo'
            })
          }}
        />

        {isNewAccountPages ? (
          <button
            data-testid="account-mobile-nav-button"
            className={styles.MobileHeader__accountButton}
            onClick={() => {
              analytics('Click', {
                category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
                label: 'My Account'
              })
              handleClickAccountIcon()
            }}
          >
            <AccountMenuIcon isLoggedIn={isLoggedIn} />
          </button>
        ) : (
          <a
            data-testid="account-mobile-nav-button"
            className={styles.MobileHeader__accountButton}
            href={`${getLink('/account')}`}
            onClick={() => {
              analytics('Click', {
                category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
                label: 'My Account'
              })
            }}
          >
            <AccountMenuIcon isLoggedIn={isLoggedIn} />
          </a>
        )}

        <a
          className={`${styles.MobileDrawer__searchButton} ${
            isSearchDrawerOpen ? styles.MobileDrawer__searchButton_active : ''
          }`}
          href={getLink('/pages/search')}
          aria-label="search"
          onClick={() => {
            analytics('Click', {
              category: 'Search',
              action: 'Open',
              label: 'Mobile'
            })
          }}
        >
          <SearchIcon />
        </a>

        <button
          aria-label="cart"
          onClick={onCartOpen}
          className={styles.MobileHeader__cartButton}
        >
          <CartMenuIcon />
        </button>

        <button
          className={styles.MobileHeader__toggleMenu}
          onClick={handleBurgerClick}
          aria-label="main navigation"
        >
          <div className={styles.MobileHeader__burger}>
            <span></span>
          </div>
        </button>
      </div>
      <MobileMenuDrawerOverlay
        isMobileMenuOpen={isMobileMenuOpen}
        handleCloseMobileMenu={handleCloseMobileMenu}
      />
    </>
  )
}
